import { Link } from "react-router-dom";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { IMG } from "../lib/assets";
import { Reveal } from "./Motion";
import { money, shipText } from "../lib/api";

const TiltHat = () => {
  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const rx = useSpring(useTransform(my, [-0.5, 0.5], [10, -10]), { stiffness: 150, damping: 18 });
  const ry = useSpring(useTransform(mx, [-0.5, 0.5], [-14, 14]), { stiffness: 150, damping: 18 });
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width - 0.5);
    my.set((e.clientY - r.top) / r.height - 0.5);
  };
  const reset = () => { mx.set(0); my.set(0); };
  return (
    <div onMouseMove={onMove} onMouseLeave={reset} className="relative [perspective:1200px]" data-testid="spotlight-hat">
      <div className="absolute inset-0 m-auto w-[85%] aspect-square rounded-full bg-[radial-gradient(circle,rgba(225,6,0,0.35),transparent_65%)] blur-2xl" />
      <motion.div style={{ rotateX: rx, rotateY: ry }} className="relative [transform-style:preserve-3d]">
        <div className="relative bg-white [clip-path:polygon(8%_0,100%_0,100%_92%,92%_100%,0_100%,0_8%)] border-0">
          <img src={IMG.hatAngle} alt="Project X hat, angled view" className="w-full aspect-[4/5] object-cover" />
        </div>
        <div className="absolute -bottom-5 -left-3 sm:-left-6 bg-[#E10600] text-white px-5 py-3 font-display text-4xl sm:text-5xl shadow-[6px_6px_0_#0B0B0B] [transform:translateZ(60px)]">
          $30
        </div>
      </motion.div>
    </div>
  );
};

export const ProductSpotlight = ({ product }) => (
  <section className="relative bg-[#F6F3EF] px-5 sm:px-10 lg:px-16 py-24 md:py-36 overflow-hidden" data-testid="product-spotlight">
    <span aria-hidden className="pointer-events-none absolute -right-10 top-6 font-display text-[40vw] leading-none text-stroke-red opacity-25 select-none">X</span>
    <div className="relative grid lg:grid-cols-12 gap-14 lg:gap-10 items-center">
      <div className="lg:col-span-6 lg:col-start-1 max-w-xl w-full mx-auto lg:mx-0">
        <Reveal><TiltHat /></Reveal>
      </div>
      <div className="lg:col-span-5 lg:col-start-8">
        <Reveal>
          <p className="font-mono-x uppercase text-xs tracking-[0.25em] text-[#E10600] font-bold">The one & only · {product?.edition}</p>
          <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9] mt-4">
            Project X <br /><span className="text-[#E10600]">Make Parties</span><br /> Great Again Hat
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 text-lg sm:text-xl font-bold leading-snug">{product?.description}</p>
        </Reveal>
        <Reveal delay={0.15}>
          <dl className="mt-10 grid grid-cols-3 border-y-2 border-[#0B0B0B]">
            {[["Hat", money(product?.price)], ["Shipping", shipText(product?.shipping)], ["Total", money((product?.price ?? 0) + (product?.shipping ?? 0))]].map(([k, v], i) => (
              <div key={k} className={`py-5 ${i ? "pl-4 border-l-2 border-[#0B0B0B]" : ""}`}>
                <dt className="font-mono-x uppercase text-[11px] tracking-[0.2em] text-zinc-600">{k}</dt>
                <dd className={`font-display text-3xl sm:text-4xl mt-1 ${i === 2 ? "text-[#E10600]" : ""}`} data-testid={`spotlight-${k.toLowerCase()}`}>{v}</dd>
              </div>
            ))}
          </dl>
          <Link
            to="/shop"
            data-testid="spotlight-shop-button"
            className="group mt-10 inline-flex items-center gap-4 bg-[#0B0B0B] text-white px-8 py-5 font-display uppercase text-2xl transition-colors duration-200 hover:bg-[#E10600]"
          >
            Get yours <ArrowUpRight className="w-6 h-6 transition-transform duration-300 group-hover:rotate-45" />
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);
